<template>
  <div class="app-container">

 <div
      v-if="movie != null"
      class="modal fade bd-example-modal-lg"
      id="viewSchedule"
      tabindex="-1"
      role="dialog"
      aria-labelledby="viewMoreLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{movie.name}} Tickets</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container mb-5">
              <div class="form-group">
                <label>Date</label>
                <input type="date" class="form-control" v-model="newSchedule.date" />
              </div>
              <div class="form-group">
                <label>Time</label>
                <input type="time" class="form-control" v-model="newSchedule.time" />
              </div>
              <button class="btn btn-primary" @click="addSchedule()">Add</button>
            </div>
            <div class="container mb-5">
              <ol class="list-group">
                <li class="list-group-item" v-for="(schedule,index) in movie.schedules" :key="index">
                  <div class="row">
                    <span class="test-dark col-3">{{ schedule.time.day }} {{ schedule.time.date }} {{ schedule.time.time }}</span>
                 
                    <button class="btn btn-danger" @click="removeSchedule(schedule.id,index)">remove</button>
                  </div>
                </li>
              </ol>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    <!-------------------------------------->
    <div
      v-if="movie != null"
      class="modal fade bd-example-modal-lg"
      id="viewTicket"
      tabindex="-1"
      role="dialog"
      aria-labelledby="viewMoreLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{movie.name}} Tickets</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container mb-5">
              <div class="form-group">
                <label>Name</label>
                <input type="text" class="form-control" v-model="newTicket.name" />
              </div>
              <div class="form-group">
                <label>Cost</label>
                <input type="text" class="form-control" v-model="newTicket.cost" />
              </div>
              <button class="btn btn-primary" @click="addTicket()">Add</button>
            </div>
            <div class="container mb-5">
              <ol class="list-group">
                <li class="list-group-item" v-for="(ticket,index) in movie.tickets" :key="index">
                  <div class="row">
                    <span class="test-dark col-3">{{ticket.name}}</span>
                    <span class="test-dark col-3">{{ticket.cost | currency}}</span>
                    <button class="btn btn-danger" @click="removeTicket(ticket.id,index)">remove</button>
                  </div>
                </li>
              </ol>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <!-- begin app-main -->
    <div class="app-main" id="main">
      <!-- begin container-fluid -->
      <div class="container-fluid">
        <!-- begin row -->
        <div class="row">
          <div class="col-md-12 m-b-30">
            <!-- begin page title -->
            <div class="d-block d-sm-flex flex-nowrap align-items-center">
              <div class="page-title mb-2 mb-sm-0">
                <h1>Events</h1>
              </div>
              <div class="ml-auto d-flex align-items-center">
                <nav>
                  <ol class="breadcrumb p-0 m-b-0">
                    <li class="breadcrumb-item">
                      <a >
                        <i class="ti ti-home"></i>
                      </a>
                    </li>
                    <li class="breadcrumb-item">Events</li>
                  </ol>
                </nav>
              </div>
            </div>
            <!-- end page title -->
          </div>
        </div>
        <!-- end row -->
        <div
          class="modal fade"
          id="createModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="createModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Create Event</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <label>Image</label>
                    <input
                      type="file"
                      id="myFilemyFile"
                      @click="encodeFile"
                      @change="encodeFile"
                      class="form-control"
                    />
                  </div>
                  

                  <div class="form-group">
                    <label>Name</label>
                    <input type="text" class="form-control" v-model="editEvent.name" />
                  </div>

                  <div class="form-group">
                    <label>Description</label>
                    <input type="text" class="form-control" v-model="editEvent.description" />
                  </div>

                  <div class="form-group">
                    <label>Preview Link</label>
                    <input type="text" class="form-control" v-model="editEvent.preview_link" />
                  </div>

                  <div class="form-group">
                    <label>Duration</label>
                    <input type="text" class="form-control" v-model="editEvent.duration" />
                  </div>

                  <div class="form-group">
                    <label>Cast</label>
                    <input type="email" class="form-control" v-model="editEvent.cast" />
                  </div>

                  <div class="form-group">
                    <label>Service Charge</label>
                    <input type="text" class="form-control" v-model="editEvent.service_charge" />
                  </div>

              

                  <div class="form-group">
                    <label>Cinema</label>
                    <select class="form-control" v-model="editEvent.cinema_id">
                      <option>Select Cinema</option>
                      <option
                        :value="cinema.id"
                        v-for="(cinema,index) in cinemas"
                        :key="index"
                        :selected="(cinema.id == editEvent.cinema_id)? 'selected' : ''"
                      >{{cinema.name}}</option>
                    </select>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button
                  type="button"
                  @click="createEvent();"
                  class="btn btn-primary"
                  data-dismiss="modal"
                >Save changes</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal -->
        <div
          class="modal fade"
          id="editModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="editModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Edit Service</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <label>Image</label>
                    <input
                      type="file"
                      id="myFilemyFile"
                      @click="encodeFile"
                      @change="encodeFile"
                      class="form-control"
                    />
                  </div>
                  

                  <div class="form-group">
                    <label>Name</label>
                    <input type="text" class="form-control" v-model="editEvent.name" />
                  </div>

                  <div class="form-group">
                    <label>Description</label>
                    <input type="text" class="form-control" v-model="editEvent.description" />
                  </div>

                  <div class="form-group">
                    <label>Preview Link</label>
                    <input type="text" class="form-control" v-model="editEvent.preview_link" />
                  </div>

                  <div class="form-group">
                    <label>Duration</label>
                    <input type="text" class="form-control" v-model="editEvent.duration" />
                  </div>

                  <div class="form-group">
                    <label>Cast</label>
                    <input type="email" class="form-control" v-model="editEvent.cast" />
                  </div>

                  <div class="form-group">
                    <label>Service Charge</label>
                    <input type="text" class="form-control" v-model="editEvent.service_charge" />
                  </div>

              

                  <div class="form-group">
                    <label>Cinema</label>
                    <select class="form-control" v-model="editEvent.cinema_id">
                      <option>Select Cinema</option>
                      <option
                        :value="cinema.id"
                        v-for="(cinema,index) in cinemas"
                        :key="index"
                        :selected="(cinema.id == editEvent.cinema_id)? 'selected' : ''"
                      >{{cinema.name}}</option>
                    </select>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button
                  type="button"
                  @click="updateEvent();"
                  class="btn btn-primary"
                  data-dismiss="modal"
                >Save changes</button>
              </div>
            </div>
          </div>
        </div>
        <!-- begin row -->
        <div class="row">
          <div class="col-lg-12">
            <Loader v-if="$store.getters.isLoading" />
            <div v-else class="card card-statistics">
              <div class="card-body">
                <Loader v-if="$store.getters.isLoading" />
                <div v-else class="export-table-wrapper table-responsive">
                  <div class="export-buttons m-b-20 row">
                    <a
                      href="#"
                      id="exportExcel"
                      class="btn btn-primary col-2"
                      @click.prevent="editEvent = {}"
                      data-toggle="modal"
                      data-target="#createModal"
                    >Create Event</a>
                    <div class="col-1"></div>
                    <select v-model="cinemaId" @change="getEvents()" class="form-control col-2">
                      <option value="all">All Cinema</option>
                      <option
                        v-for="(cinema,index) in cinemas"
                        :key="index"
                        :value="cinema.id"
                      >{{ cinema.name | capitalize }}</option>
                    </select>

                             

                    <div class="col-3">
                      <input
                        type="text"
                        v-model="keyword"
                        @keyup="searchEvents()"
                        placeholder="search"
                        class="form-control"
                      />
                      <div
                        v-if="interval != null"
                        class="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>

                  <table id="export-table" class="table table-bordered">
                    <thead class="thead-light">
                      <tr>
                        <th>Image</th>
                        <th>Name</th>
                      
                        <th>Cinema</th>
                        <th>Service Charge</th>
                        <th>Duration</th>

                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>       
                      </tr>
                    </thead>
                    <tbody>
                      <span v-if="movies.length < 1">No Movies Found</span>
                      <tr v-for="(movie,index) in movies" :key="index">
                        <td>
                          <img
                            :src="movie.image"
                            class="profile-image"
                            style="width: 50px; height: 50px;"
                            alt="LOGO"
                          />
                        </td>
                        <td>{{movie.name}}</td>
                
                        <td>{{movie.cinema.name }}</td>
                        <td>{{movie.service_charge | currency }}</td>
                        <td>{{movie.duration }}</td>

                        <td>
                          <button
                            class="btn btn-primary"
                            data-toggle="modal"
                            data-target="#viewTicket"
                            @click="loadOrder(movie,index)"
                            
                          >View Tickets</button>
                        </td>
                         <td>
                          <button
                            class="btn btn-primary"
                            data-toggle="modal"
                            data-target="#viewSchedule"
                            @click="loadOrder(movie,index)"
                           
                          >View Schedule</button>
                        </td>
                        <td>
                          <button
                            class="btn btn-secondary mr-5"
                            @click.prevent="editing = true; prepEdit(movie)"
                            data-toggle="modal"
                            data-target="#editModal"
                          >&#9998;</button>
                        </td>

                        <td>
                          <button
                            class="btn btn-danger"
                            @click.prevent="deleteEvent(movie.id,index)"
                          >🗑</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <sliding-pagination
                    v-if="movies.length > 0"
                    :current="currentPage"
                    :total="totalPages"
                    @page-change="pageChangeHandler"
                  ></sliding-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container-fluid -->
    </div>
    <!-- end app-main -->
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Loader from "../../components/Loader.vue";
export default {
  data() {
    return {
      cinemas: [],
      editing: false,
      cinema: "all",
      currentPage: 1,
      editEvent: {},
      movies: [],
      totalPages: 1,
      keyword: "",
      movie: {},
      index: null,
      selectedLocation: "",
      interval: null,
      cinemaId: "all",
      free: "all",
      newTicket: {},
      newSchedule: {},
    };
  },
  components: {
    Loader
  },
  mounted() {
    this.getCinemas();
    this.getEvents();
  },
  methods: {
    searchEvents() {
      if (this.interval != null) {
        clearTimeout(this.interval);
        this.interval = null;
      }
      this.interval = setTimeout(this.querySearch, 2000);
    },
    querySearch() {
      clearTimeout(this.interval);
      this.interval = null;
      if (this.keyword.length < 1) {
        this.getOrders();
        return;
      }

      fetch(
        this.$store.getters.baseURL +
          "movies/movies/" +
          encodeURI(this.keyword) +
          "/search?page=" +
          this.currentPage,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.getToken
          }
        }
      )
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.movies = result.data.data;
            this.currentPage = result.data.current_page;
            this.totalPages = result.data.last_page;
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
        });
    },
    loadOrder(movie, index) {
      this.movie = { ...movie };
      this.index = index;
    },
    pageChangeHandler(page) {
      this.currentPage = page;
      if (this.keyword.length < 1) this.getEvents();
      else this.querySearch();
    },
    encodeFile(e) {
      let file = e.target.files[0];
      if (!file) return;

      let reader = new FileReader();
      reader.onloadend = () => {
        this.editEvent.image = reader.result;
      };
      reader.readAsDataURL(file);
    },
    prepEdit(cinema) {
      console.log(cinema);
      this.editEvent = { ...cinema };
      this.editEvent.image = null;
      this.editEvent.date = cinema.time.date;
      this.editEvent.time = cinema.time.time;

      console.log(this.editEvent);
    },
    getCinemas() {
      this.$store.commit("setLoading", true);
      fetch(this.$store.getters.baseURL + "movies/cinemas/all/all", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$store.getters.getToken
        }
      })
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.cinemas = result.data.data;
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },
    getEvents() {
      this.$store.commit("setLoading", true);
      fetch(
        this.$store.getters.baseURL +
          `movies/movies/${this.cinemaId}/all?page=` +
          this.currentPage,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.getToken
          }
        }
      )
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.movies = result.data.data;
            this.currentPage = result.data.current_page;
            this.totalPages = result.data.last_page;
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },
    deleteEvent(id, index) {
      const link =
        this.$store.getters.baseURL + "movies/movies/" + id + "/destroy";

      Swal.queue([
        {
          icon: "warning",
          title: "Delete movie?",
          confirmButtonText: "Confirm Delete!",
          showCancelButton: true,
          text: "This action is irreversible and can break the system",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            return fetch(link, {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.$store.getters.getToken
              }
            })
              .then(response => response.json())
              .then(result => {
                if (result.status) {
                  Swal.insertQueueStep({
                    icon: "success",
                    title: result.message
                  });
                  this.movies.splice(index, 1);
                } else {
                  Swal.insertQueueStep({
                    icon: "error",
                    title: result.message
                  });
                }
              })
              .catch(() => {
                Swal.insertQueueStep({
                  icon: "error",
                  title: "Some thing went wrong",
                  text: "Check your internet connection"
                });
              });
          }
        }
      ]);
    },

    updateEvent() {
      this.editEvent.free = Number(this.editEvent.free);
      this.$store.commit("setLoading", true);
      fetch(
        this.$store.getters.baseURL +
          "movies/movies/" +
          this.editEvent.id +
          "/update",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.getToken
          },
          body: JSON.stringify(this.editEvent)
        }
      )
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            let artisanIndex = this.movies.findIndex(movie => {
              if (movie.id == this.editEvent.id) return true;
            });
            this.movies[artisanIndex] = result.data;
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },

    createEvent() {
      this.editEvent.free = Number(this.editEvent.free);
      this.$store.commit("setLoading", true);
      fetch(this.$store.getters.baseURL + "movies/movies/create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$store.getters.getToken
        },
        body: JSON.stringify(this.editEvent)
      })
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.movies = [result.data, ...this.movies];
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },
    getUnassignedLocations(id) {
      console.log(this.movie);
      this.$store.commit("setLoading", true);
      fetch(
        this.$store.getters.baseURL + `cinemas/movies/${id}/unassigned_location`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.getToken
          },
          method: "PUT"
        }
      )
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.unassignedLocation = result.data;
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },
    addTicket() {
      this.$store.commit("setLoading", true);

      fetch(
        this.$store.getters.baseURL +
          `movies/movies/${this.movie.id}/add_ticket`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.getToken
          },
          method: "PUT",
          body: JSON.stringify(this.newTicket)
        }
      )
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.movie.tickets = [result.data, ...this.movie.tickets];
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },
    removeTicket(locationId, index) {
      this.$store.commit("setLoading", true);

      fetch(
        this.$store.getters.baseURL +
          `movies/movies/${this.movie.id}/remove_ticket`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.getToken
          },
          method: "PUT",
          body: JSON.stringify({ ticket_id: locationId })
        }
      )
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.movie.tickets.splice(index, 1);
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },
    addSchedule() {
      this.$store.commit("setLoading", true);

      fetch(
        this.$store.getters.baseURL +
          `movies/movies/${this.movie.id}/add_schedule`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.getToken
          },
          method: "PUT",
          body: JSON.stringify(this.newSchedule)
        }
      )
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.movie.schedules = [result.data, ...this.movie.schedules];
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },
    removeSchedule(scheduleId, index) {
      this.$store.commit("setLoading", true);

      fetch(
        this.$store.getters.baseURL +
          `movies/movies/${this.movie.id}/remove_schedule`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.getToken
          },
          method: "PUT",
          body: JSON.stringify({ schedule_id: scheduleId })
        }
      )
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.movie.schedules.splice(index, 1);
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    }
  }
};
</script>

<style scoped></style>
